import { Container, Content, Label, Loader } from "./styles";

interface Props {
  open: boolean;
  label: string;
  loadingSize?: number;
}

const LoadingModal = ({ open, label, loadingSize = 50 }: Props) => {
  return (
    <Container open={open}>
      <Content>
        <Loader size={loadingSize} />
        <Label variant="h6">{label}</Label>
      </Content>
    </Container>
  );
};

export default LoadingModal;
